module.exports = __webpack_public_path__ + "static/media/About.4c900260.md";